import Can from "../../utils/can";
import Ratings from "../systemsettings/ratings";

const RatingsPage = () => {
  return (
    <div className="row">
      <Can permission={"view_rating_key"}>
        <Ratings />
      </Can>
    </div>
  );
};

export default RatingsPage;
